import {Component, Input, OnInit} from '@angular/core';
import {DigitizationService} from '@services/shared/digitization/digitization.service';
import {AutoUnsubscribe} from '@decorators/auto-unsubscribe';
import {Subscription} from 'rxjs';
import {take} from 'rxjs/operators';
import {Digitization} from '@components/main/spreading/models/digitization';
import {NgxPopupComponent} from "@components/shared/ngx-popups/ngx-popups/components/popup.component";
import {FormControl, Validators} from "@angular/forms";

@Component({
    selector: 'app-prompt-for-projection-name',
    templateUrl: './prompt-for-projection-name.component.html',
    styleUrls: ['./prompt-for-projection-name.component.scss'],
    standalone: false
})
@AutoUnsubscribe('subscriptions$')
export class PromptForProjectionNameComponent implements OnInit {
  @Input() popup: NgxPopupComponent;
  @Input() statementDate: string = '';
  @Input() reportingInterval: string = '';
  @Input() digitizationId: number = 0;

  subscriptions$: Subscription[] = [];

  digitization: Digitization;
  errorMessage: string;
  hasError: boolean;
  submitAttempt = false;
  projectionNameControl: FormControl<string> = new FormControl<string>("", [Validators.required, Validators.maxLength(200)])

  constructor(
    private digitizationService: DigitizationService,
  ) {
  }

  ngOnInit(): void {
    // Subscribe to digitization service
    this.subscriptions$.push(
      this.digitizationService.digitization$.subscribe((digitization: Digitization) => {
        this.digitization = digitization;
        // Set the current projection name in the input field if it exists
        if (digitization?.projectionName) {
          this.projectionNameControl.setValue(digitization.projectionName);
        }
      })
    );
  }

  save(): void {
    this.submitAttempt = true;
    if (!this.projectionNameControl.valid) {
      return;
    }
    // Use digitizationId from input if available, otherwise fall back to digitization.id
    const idToUse = this.digitizationId || (this.digitization?.id);
    
    if (!idToUse) {
      this.hasError = true;
      this.errorMessage = 'Unable to determine digitization ID. Please try again.';
      return;
    }
    this.hasError = false;
    this.errorMessage = '';
    this.subscriptions$.push(
      this.digitizationService.updateProjectionName(
        idToUse,
        this.projectionNameControl.value.trim()
      ).pipe(take(1)).subscribe(
        (updatedDigitization) => {
          // Update the local digitization object with the new projection name
          if (this.digitization) {
            this.digitization.projectionName = updatedDigitization.projectionName;
          }         
          // Update the form control to show the saved value
          this.projectionNameControl.setValue(updatedDigitization.projectionName);
          this.popup.close(true, true);
        }, 
        () => {
          this.hasError = true;
          this.errorMessage = 'An error occurred while saving the projection name.';
        }
      )
    );
  }

  /**
   * Format reporting interval to camelCase
   */
  formatReportingInterval(reportingInterval: string): string {
    if (!reportingInterval) return '';
    const lowerCase = reportingInterval.toLowerCase();
    return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1);
  }
}
